import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import buildingsApi from '../../../APIs/buildings';
import { ReactComponent as DeleteSVG } from '../../../assets/icons/delete.svg';
import { ReactComponent as UpdateSVG } from '../../../assets/icons/refresh.svg';
import BlueprintInformation from '../../../components/BuildingsDetails/BlueprintInformation';
import BuildingInformation from '../../../components/BuildingsDetails/BuildingInformation';
import ConfirmationModalBuilding from '../../../components/ConfirmationModal/ConfirmationModal';
import {
  Button,
  Divider,
  Flex,
  Loader,
  NavigateBack,
  Typography,
} from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { humanReadableDateWithTime, requestAPI } from '../../../utils';
import {
  ActionsContainer,
  ViewJobContainerStyled,
} from '../../BrowseJobs/BrowseJobDetails/style';
// import { BuildingAndBlueprintInformationWrapperStyled } from './style';

interface BuildingDataType {
  bluePrints: {
    bluePrintUrl: string;
    title: string;
    _id: string;
  }[];
  buildingAddress: string;
  buildingName: string;
  createdAt: string;
  createdBy: { _id: string; fullName: string };
  notes: string;
  updatedAt: string;
  _id: string;
}

const ViewBuildingDetails = () => {
  const [loading, setLoading] = useState(false);
  const [buildingData, setBuildingData] = useState<BuildingDataType>();
  const [showModal, setShowModal] = useState(false);
  const { buildingId } = useParams();
  const navigate = useNavigate();

  const buildingsDetails = useSelector(
    (state: RootState) => state.buildingsDetails,
  );

  const getBuildingDetails = async (id: string) => {
    try {
      setLoading(true);
      const buildings = await requestAPI(buildingsApi.getBuildingsDetails(id));
      setBuildingData(buildings);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (buildingId) {
      getBuildingDetails(buildingId);
    }
  }, [buildingId]);
  const formatData = () => {
    if (buildingData) {
      const newData = buildingData.bluePrints.map((item) => ({
        name: item.title,
        id: item._id,
        URL: item.bluePrintUrl,
      }));
      return newData;
    }
    return [];
  };

  const onUpdate = () => {
    navigate(`/buildings/add?edit=building-${buildingId}`);
  };
  const handleDeleteBuilding = async () => {
    try {
      setLoading(true);
      if (!buildingsDetails?._id) {
        return;
      }

      await requestAPI(buildingsApi.deleteBuilding(buildingsDetails._id));
      toast.success('Building deleted successfully');
      navigate(-1);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      console.error('Error While Deleting Job:', error);
      toast.error(error);
    }
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const createAtDate =
    typeof buildingsDetails.createdAt === 'string'
      ? humanReadableDateWithTime(buildingsDetails.createdAt)
      : '';

  return (
    <ViewJobContainerStyled>
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <div className="contents">
        <Typography variant="title" style={{ marginLeft: '12px' }}>
          Building Details
        </Typography>
        <Divider />
        {loading ? (
          <Loader
            type="spinner"
            style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
          />
        ) : (
          <>
            <BuildingInformation
              buildingCreatedAt={createAtDate}
              buildingName={buildingsDetails?.buildingName || ''}
              addressOfProperty={buildingsDetails?.buildingAddress || ''}
            />
            <Divider />
            <BlueprintInformation
              blueprintOfProperty={buildingsDetails?.bluePrints ? 'Yes' : 'No'}
              floorTitle={formatData()}
              note={buildingsDetails?.notes || ''}
            />
            <Divider spaceY="20px" />
            <Typography
              variant="normal"
              strong
              fontColor="secondary"
              className="section-title"
            >
              ACTIONS
            </Typography>
            <ActionsContainer>
              <Button variant="secondary" onClick={onUpdate}>
                <UpdateSVG />
                Update
              </Button>
              <Button
                variant="danger"
                onClick={() => setShowModal(true)}
                isLoading={loading}
              >
                <DeleteSVG /> Delete
              </Button>
            </ActionsContainer>
          </>
        )}
      </div>

      <ConfirmationModalBuilding
        message={`Are you sure you want to delete "${buildingsDetails.buildingName}" ?`}
        isOpen={showModal}
        onClose={handleCloseModal}
        loading={loading}
        title="Delete Building"
      >
        <Flex justifyContent="space-between">
          <Button
            variant="danger"
            onClick={handleDeleteBuilding}
            isLoading={loading}
            isDisabled={loading}
          >
            Delete
          </Button>
          <Button
            variant="cancel"
            onClick={handleCloseModal}
            isDisabled={loading}
          >
            Cancel
          </Button>
        </Flex>
      </ConfirmationModalBuilding>
    </ViewJobContainerStyled>
  );
};

export default ViewBuildingDetails;
